import styled from "styled-components";

import * as Types from "Types";

const Img = styled.img<Types.DefaultImage>`
   ${({ css }) => css}
`;

export default function NowTile(props: Types.DefaultImage) {
   return <Img src={props.src} css={props.css}></Img>;
}
